import { useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import { type License } from 'src/shared/features/users/schemas/licenses'

const getMyLicenses = () => getRequest<License[]>('/users/licenses/me')

export const useMyLicenses = () => {
  return useSuspenseQuery({
    ...queries.users.me._ctx.licenses,
    queryFn: getMyLicenses,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
